<template>
  <v-menu
    v-model="mostrar"
    :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(opcion, index) in opciones"
        :key="index"
        :to="{ name: opcion.ruta }">
        <v-list-item-content>
          <v-list-item-title>{{ opcion.nombre }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'OpcionesContratos',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
      opciones: [
        {
          nombre: 'Anticipos',
          ruta: 'estimaciones',
          icono: '',
        },
        {
          nombre: 'Fianzas',
          ruta: 'estimaciones',
          icono: '',
        },
        {
          nombre: 'Convenios',
          ruta: 'estimaciones',
          icono: '',
        },
        {
          nombre: 'Catálogo',
          ruta: 'estimaciones',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
